import Icon from '@ant-design/icons';
import styled from 'styled-components';
import DefaultCloseIcon from '../../icons/defaultCloseIcon.svg';
import { CloseButtonCss } from '../default/CloseButton';
import LocalButton from './Button';

const Button = styled(LocalButton)`
    ${CloseButtonCss}
`;

const CloseButton = props => <Button {...props} icon={<Icon component={DefaultCloseIcon} />} />;

export default CloseButton;
